import React, { useEffect, useState, useCallback } from "react";
import axios from "../axios";
import "./IncomeTaxPassword.css"; // Create this CSS file for styling

const API_URL = process.env.REACT_APP_API_URL;

const IncomeTaxPassword = () => {
  const [records, setRecords] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const token = localStorage.getItem("access_token"); // Retrieve token from localStorage

  const [formData, setFormData] = useState({
    surname: "",
    middle_name: "",
    first_name: "",
    user_id: "",
    password: "",
    dob: "",
    aadhaar: "",
    name_as_per_aadhaar: "",
    email: "",
    alt_password: "",
    phone: "",
    father_name: "",
  });
  const [editingId, setEditingId] = useState(null);

  // Move fetchData to the component scope
  const fetchData = useCallback(async () => {
  try {
    const res = await axios.get(`${API_URL}api/income-tax/`);
    setRecords(res.data);
  } catch (error) {
    console.error(error);
  }
}, []);
  
  useEffect(() => {
    fetchData();
  }, [fetchData]); // Add fetchData to dependencies since it's memoized
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "surname",
      "user_id",
      "password",
      "dob",
      "aadhaar",
      "name_as_per_aadhaar",
      "phone",
    ];

    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(`❌ Please fill in the required field: ${field.replaceAll("_", " ")}`);
        return;
      }
    }

    console.log("FormData being submitted:", formData);

    try {
      if (editingId) {
        await axios.put(`${API_URL}api/income-tax/${editingId}/`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_URL}api/income-tax/`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      setFormData({
        surname: "",
        middle_name: "",
        first_name: "",
        user_id: "",
        password: "",
        dob: "",
        aadhaar: "",
        name_as_per_aadhaar: "",
        email: "",
        alt_password: "",
        phone: "",
        father_name: "",
      });
      setEditingId(null);
      setIsFormVisible(false);
      fetchData(); // Refresh the records
    } catch (err) {
      console.error("🚨 API submission error:", err.response?.data || err.message);
      alert("Something went wrong. Please check your input and try again.");
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setEditingId(record.id);
    setIsFormVisible(true); // ✅ Show form when editing
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}api/income-tax/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData(); // Refresh the records
    } catch (error) {
      console.error("Error deleting record:", error.response?.data || error.message);
      alert("Failed to delete the record.");
    }
  };

  return (
    <div className="income-tax-container">
      <h2 className="section-title">Income Tax Password Management</h2>

      <button
        onClick={() => {
          setFormData({
            surname: "",
            middle_name: "",
            first_name: "",
            user_id: "",
            password: "",
            dob: "",
            aadhaar: "",
            name_as_per_aadhaar: "",
            email: "",
            alt_password: "",
            phone: "",
            father_name: "",
          });
          setEditingId(null);
          setIsFormVisible(true); // ✅ Show empty form
        }}
        className="submit-btn"
        style={{ marginBottom: "20px" }}
      >
        ➕ Add New Record
      </button>

      <input
        type="text"
        placeholder="🔍 Search by surname..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {isFormVisible && (
        <form className="income-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            {Object.entries(formData).map(([key, value]) => (
              <div key={key} className="form-group">
                <label>{key.replaceAll("_", " ")}</label>
                <input
                  type={key === "dob" ? "date" : "text"}
                  name={key}
                  value={value}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
          <button type="submit" className="submit-btn">
            {editingId ? "Update" : "Create"}
          </button>
        </form>
      )}
      <div className="table-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Surname</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Password</th>
              <th>DOB</th>
              <th>Aadhaar</th>
              <th>Name as per Aadhaar</th>
              <th>Email</th>
              <th>Alt Password</th>
              <th>Phone</th>
              <th>Father Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records
              .filter((rec) =>
                rec.surname.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map((rec) => (
                <tr key={rec.id}>
                  <td>{rec.user_id}</td>
                  <td>{rec.surname}</td>
                  <td>{rec.first_name}</td>
                  <td>{rec.middle_name}</td>
                  <td>{rec.password}</td>
                  <td>{rec.dob}</td>
                  <td>{rec.aadhaar}</td>
                  <td>{rec.name_as_per_aadhaar}</td>
                  <td>{rec.email}</td>
                  <td>{rec.alt_password}</td>
                  <td>{rec.phone}</td>
                  <td>{rec.father_name}</td>
                  <td>
                    <button onClick={() => handleEdit(rec)} className="edit-btn">
                      Edit
                    </button>
                    <button onClick={() => handleDelete(rec.id)} className="delete-btn">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IncomeTaxPassword;
